function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#279FD3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.069 0H1.862C.807 0 0 .79 0 1.821v12.143c0 1.032.807 1.822 1.862 1.822h1.241c.373 0 .621-.243.621-.607 0-.365-.248-.608-.62-.608H1.861c-.372 0-.62-.242-.62-.607V1.821c0-.364.248-.607.62-.607h.62v.182c0 .911.746 1.64 1.677 1.64h1.613c.931 0 1.676-.729 1.676-1.64v-.182h.621c.372 0 .62.243.62.607v5.465c0 .364.249.607.621.607.373 0 .621-.243.621-.607V1.82C9.931.79 9.124 0 8.069 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 9.107V8.5c0-1.032-.807-1.821-1.862-1.821H4.345c-1.055 0-1.862.789-1.862 1.821v.607H18zM2.483 10.321v4.858C2.483 16.21 3.29 17 4.345 17h11.793C17.193 17 18 16.21 18 15.179V10.32H2.483zm11.669 4.25c-.31 0-.621-.121-.87-.364a1.239 1.239 0 0 1-.868.364c-.683 0-1.242-.546-1.242-1.214 0-.668.559-1.214 1.242-1.214.31 0 .62.121.869.364.248-.243.558-.364.869-.364.682 0 1.241.546 1.241 1.214 0 .668-.559 1.214-1.241 1.214z"
}));

function SvgMobileMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMoney);
export default __webpack_public_path__ + "static/media/mobile-money.5b782239.svg";
export { ForwardRef as ReactComponent };